/**
 * 수정본(TipTap) HTML을 추출용 DOM으로 파싱한다(spec 설계 결정 4).
 *
 * 현재 문서의 detached 요소에 `innerHTML`로 넣으면 이미지 요청·onerror가 실행되므로,
 * `new DOMParser().parseFromString(html, "text/html")`로 **별도 문서**에 파싱한다.
 * 그래서 파싱 결과의 `ownerDocument`는 `document`와 다르다.
 */
export function parseEditedHtmlToRoot(html: string): HTMLElement {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body;
}
